<style lang="scss">
body {
    background: white;
    height: 100%;
    font-family: "Microsoft YaHei", sans-serif;
}
.dy_index {
    .flex {
        display: flex;
    }

    background: white;
    .site_banner {
        background: url(../../assets/images/dy/all.png) #51b5c8 no-repeat center
            center;
        height: 300px;
        text-align: center;
        width: auto;
        background-position: 0 -1303px;
        line-height: 300px;
        img {
            vertical-align: middle;
        }
    }
    .content {
        width: 1170px;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 120px;
        & > div {
            &:nth-child(2n + 1) {
                margin-right: 25px;
            }
            padding: 0 10px;
            width: 570px;
            height: 385px;
            box-sizing: border-box;
            border: 1px solid #f5f5f5;
            margin-top: 20px;
            -moz-border-radius: 20px;
            -webkit-border-radius: 20px;
            border-radius: 10px;
            background-color: #fff;
            box-shadow: -3px 0 10px #ebebeb, 3px 0 10px #ebebeb,
                0 -3px 10px #ebebeb, 0 3px 10px #ebebeb;
        }
        .label {
            font-family: "Microsoft YaHei", sans-serif;
            display: flex;
            height: 50px;
            box-sizing: border-box;
            width: 100%;
            font-size: 22px;
            font-weight: 800;
            color: #27a3bd;
            align-items: center;
            border-bottom: 3px solid #eee;

            .line {
                height: 18px;
                width: 5px;
                background: #27a3bd;
                margin-right: 10px;
            }
            .an {
                width: 500px;
                justify-content: space-between;
            }
            .more {
                a {
                    color: #333;
                    font-weight: 500;
                    font-size: 16px;
                }
            }
        }
        .border_white {
            border-bottom: 3px solid white;
        }
        .noticeList {
            li {
                border-bottom: solid 1px #eee;
                padding: 2px 10px;
                line-height: 35px;
                &:last-child {
                    border-bottom: 0;
                }
                .dian {
                    padding-left: 15px;
                    text-align: center;
                    background: url(../../assets/images/dy/all.png);
                    height: 8px;
                    width: 10px;
                    background-position: 0 -1125px;
                    margin-top: 12px;
                }
                a {
                    display: block;
                    width: 100%;
                    color: #333;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
        .regList {
            height: 35px;
            .areaList {
                padding: 2px 15px;
                height: 35px;
                display: flex;
                align-items: center;
                a {
                    &:nth-of-type(1) {
                        background: #27a3bd;
                        padding: 2px 10px;
                        color: white;
                    }
                    padding: 2px 10px;
                    margin-right: 5px;
                    &:hover {
                        background: #27a3bd;
                        padding: 2px 10px;
                        color: white;
                    }
                }
            }
        }
        .pc-liucheng {
            margin-top: 10px;
            padding-left: 15px;
            padding-right: 10px;
            text-align: center;
            background: url(../../assets/images/dy/all.png);
            height: 262px;
            width: 506px;
            background-position: 30px -139px;
        }
        .shijian {
            margin-top: 10px;
            .pc-shijian {
                margin-top: 5px;
                margin-left: 5px;
                background: url(../../assets/images/dy/all.png);
                height: 295px;
                width: 120px;
                background-position: 2px -402px;
                margin-top: 6px;
            }
            .shijian_list {
                div {
                    line-height: 42px;
                    vertical-align: middle;
                    padding-left: 10px;
                    padding-right: 10px;
                    border-bottom: solid 1px #eee;
                }
            }
        }
    }
    .footer {
        width: 100%;
        position: relative;
        bottom: 0;
        text-align: center;
        border-top: solid 1px #ccc;
        line-height: 80px;
        .containerzz {
            background: url(../../assets/images/dy/all.png);
            height: 58px;
            line-height: 58px;
            width: 400px;
            background-position: 0 -1765px;
            text-align: center;
            margin: 0 auto;
            margin-top: 20px;
        }
    }
}
</style>
<template>
    <div class="dy_index">
        <div class="site_banner">
            <img src="../../assets/images/dy/logo.png">
        </div>
        <div class="content">
            <div>
                <div class="label">

                    <div class="line"> </div>
                    <div class="flex an">
                        <div class="title">考试公告</div>
                        <div class="more">
                            <router-link
                                target="_blank"
                                :to="{name:'default.noticePage'}"
                            >
                                more >
                            </router-link>
                        </div>
                    </div>

                </div>
                <ul class="noticeList">
                    <template v-for="(testInform,index) in testInforms">
                        <li v-if="index<8">

                            <div
                                class="dian"
                                style="float: left"
                            ></div>
                            <router-link
                                target="_blank"
                                :to="{name:'default.dynotice',query:{id:testInform.id}}"
                            >
                                {{testInform.title}}
                            </router-link>

                        </li>
                    </template>

                </ul>
            </div>
            <div>
                <div class="label border_white">

                    <div class="line"> </div>
                    <div class="flex an">
                        <div class="title">报考信息</div>
                    </div>

                </div>
                <ul class="regList">
                    <li class="areaList">
                        <a>华北</a>
                        <a @click="goBatch('202006041552515837826287')">北京</a>
                        <a @click="goBatch('202006031125456044877253')">天津</a>
                        <a @click="goBatch('202006011654209994288114')">河北</a>
                        <a>山西</a>
                        <a>内蒙古</a>
                    </li>
                    <li class="areaList">
                        <a>东北</a>
                        <a>辽宁</a>
                        <a>吉林</a>
                        <a>黑龙江</a>
                    </li>
                    <li class="areaList">
                        <a>华东</a>
                        <a>上海</a>
                        <a>江苏</a>
                        <a>浙江</a>
                        <a>安徽</a>
                        <a>福建</a>
                        <a>江西</a>
                        <a>山东</a>
                    </li>
                    <li class="areaList">
                        <a>中南</a>
                        <a>河南</a>
                        <a>湖北</a>
                        <a>湖南</a>
                    </li>
                    <li class="areaList">
                        <a>华南</a>
                        <a>广东</a>
                        <a>广西</a>
                        <a>海南</a>
                    </li>
                    <li class="areaList">
                        <a>西南</a>
                        <a>重庆</a>
                        <a>四川</a>
                        <a>贵州</a>
                        <a>云南</a>
                        <a>西藏</a>
                    </li>
                    <li class="areaList">
                        <a>西北</a>
                        <a>陕西</a>
                        <a>甘肃</a>
                        <a>青海</a>
                        <a>宁夏</a>
                        <a>新疆</a>
                        <a>兵团</a>
                    </li>
                </ul>
            </div>
            <div>
                <div class="label border_white">

                    <div class="line"> </div>
                    <div class="flex an">
                        <div class="title">报考流程</div>
                    </div>
                </div>
                <div class="process">
                    <div class="pc-liucheng"></div>
                </div>
            </div>
            <div>
                <div class="label">

                    <div class="line"> </div>
                    <div class="flex an">
                        <div class="title">考试信息</div>
                    </div>

                </div>
                <div class="shijian flex">
                    <div class="pc-shijian"></div>
                    <div class="shijian_list">
                        <div> 2020年8月20日9:00至9月20日17:00</div>
                        <div>2019年8月20日9:00至9月30日17:00</div>
                        <div>截止到2019年10月8日17:00</div>
                        <div>2019年11月22日9:00起</div>
                        <div>2019年11月30日9:00-12:00</div>
                        <div>以各省市考试公告为准</div>
                        <div>2020年4月28日9:00起</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="containerzz">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            testInforms: [],
            pageIndex: 1,
            pageSize: 10
        };
    },
    created: function() {
        this.getData();
    },
    watch: {},
    methods: {
        goBatch(code) {
            this.$router.push({
                name: "batch_main",
                params: {
                    projectCode: "zhongxintest",
                    batchCode: code
                }
            });
        },
        getkefu: function(id, type) {
            if (type == "live800") {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src =
                    "https://live800.ata-test.net.cn/live800/chatClient/staticButton.js?companyID=228&configID=" +
                    id +
                    "&codeType=steady&delayload=1";
                document.getElementsByTagName("head")[0].appendChild(script);
                var script2 = document.createElement("script");
                script2.type = "text/javascript";
                script2.src =
                    "https://live800.ata-test.net.cn/live800/chatClient/monitor.js?companyID=228&configID=1&codeType=custom&delayload=1";
                document.getElementsByTagName("head")[0].appendChild(script2);
                var script3 = document.createElement("script");
                script3.innerHTML =
                    "function writehtml(){var temptext=StaticIcon_generate();document.getElementById('live81').innerHTML=temptext;setTimeout('write.src',9000);}setTimeout('writehtml()',1500);";
                document.getElementsByTagName("head")[0].appendChild(script3);
            } else {
                let code, link;
                let kefuInfo = id.split("+");
                if (kefuInfo.length > 1) {
                    code = kefuInfo[0].toString();
                    link = kefuInfo[1].toString();
                }
                //udesk
                let udeskScript = document.createElement("script");
                udeskScript.type = "text/javascript";
                udeskScript.innerHTML = `(function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.charset="utf-8";g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})(window,document,"script","https://assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
ud({
    "code": '${code}',
    "link": '${link}',
});
`;
                document
                    .getElementsByTagName("head")[0]
                    .appendChild(udeskScript);
            }
        },
        getInfo: function(domain) {
            this.$http
                .get(globalProvider.serviceUrl("ea/g/pcas/{domain}"), {
                    params: {
                        domain: "zhongxintest"
                    }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        if (data.body.data) {
                            if (data.body.data.online_chat) {
                                this.getkefu(
                                    data.body.data.online_chat,
                                    data.body.data.chat_type
                                );
                            }
                        }
                    } else
                        this.$router.push({
                            name: "default.notFound"
                        });
                });
        },
        getNormalAnn: function(captcha_token) {
            let url;
            url =
                "ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/PROJECT";

            this.$http
                .get(globalProvider.serviceUrl(url), {
                    params: {
                        domain: "zhongxintest",
                        page_index: this.pageIndex,
                        page_size: this.pageSize,
                        n_type: "se"
                    },
                    headers: {
                        ttoken: captcha_token
                    },
                    emulateJSON: false
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        data.body.data.map(item => {
                            if (item.type == 1) {
                                this.testInforms = item._items;
                                this.total = item.totalCount;
                                this.pageIndex = item.pageIndex;
                            }
                        });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(
                            getErrorMessage(data.body.message),
                            "提示",
                            {
                                confirmButtonText: "确定"
                            }
                        );
                    }
                });
        },
        getData() {
            this.getNormalAnn();
            this.getInfo();
        }
    }
};
</script>